export default {
  path: 'client-applications',
  name: 'client-applications.index',
  component: () => import('@/views/admin/client-applications/Index'),
}